import * as React from "react";
import StatisticButton from "./StatisticButton";
import helpIcon from "../../../../assets/images/classes/icon-help-line.png";
import {useState} from "react";
import Modal from "../../../../components/Modal";
import PopupKeywordInfo from "../../../../assets/images/classes/popup_keywork_info.png"

const StatisticSection = ({ title, buttons, wrapperClass, setActiveFilter, activeFilter }) =>{
    const [isKeywordGuideModalOpen, setIsKeywordGuideModalOpen] = useState(false);

    return (
        <div className={wrapperClass}>
            <div className="flex flex-col flex-1 self-stretch">
                <div className="flex gap-1 items-center self-start text-base font-black text-zinc-600">
                    <div className="self-stretch my-auto">{title}</div>
                    {title==="키워드 분석" &&
                        <img
                        className="cursor-help inline-block"
                        src={helpIcon}
                        alt="Help Icon"
                        onClick={() => setIsKeywordGuideModalOpen(true) }
                    />}
                </div>
                <div className="flex gap-2.5 mt-3 w-full text-center flex-wrap">
                    {buttons.map((button, index) => (
                        <StatisticButton
                            key={index}
                            {...button}
                            isActive={activeFilter === button.filterType} // 현재 활성화된 필터 확인
                            setActiveFilter={setActiveFilter}
                        />
                    ))}
                </div>
            </div>
            <Modal
                isOpen={isKeywordGuideModalOpen}
                onClose={() => setIsKeywordGuideModalOpen(false)}
                onCloseBtn={true}
                width={936}
                onClickBack={true}
            >
                <img
                    src={PopupKeywordInfo}
                    alt="keyword guide"
                />
            </Modal>
        </div>
    );
}
export default StatisticSection;